import { render, staticRenderFns } from "./myOrderFreight.vue?vue&type=template&id=4c6f49ea&scoped=true"
import script from "./myOrderFreight.vue?vue&type=script&lang=js"
export * from "./myOrderFreight.vue?vue&type=script&lang=js"
import style0 from "./myOrderFreight.vue?vue&type=style&index=0&id=4c6f49ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6f49ea",
  null
  
)

export default component.exports